import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentDepartmentHit as Type } from '../../../../SearchAllContent/types';
import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';

import TaxonomyDepartmentCard from '../../../../../implementations/Taxonomy/Department/Card';

const MetaSearchDepartmentHit: React.FC<{ hit: Type }> = ({ hit }) => (
  <TaxonomyDepartmentCard
    title={hit.taxonomy_name[0]}
    subtitle={hit.taxonomy_description?.[0]}
    image={(
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['16_9', '3_1', '2_3', '2_3', '2_3'],
          ['sm', 'md', 'md', 'md', 'md'],
        )}
        alt=""
        lazyload={false}
      />
    )}
    link={hit.url[0]}
  />
);

export default MetaSearchDepartmentHit;
